import React from "react";
import { NavLink } from "react-router-dom";
import { Nav, NavItem } from "reactstrap";

const abas = [
  { to: "/relatorios/notasDaTurma", label: "Notas da Turma" },
  { to: "/relatorios/planilhaDeNotas", label: "Planilha de Notas" },
];

export function RelatoriosAbas() {
  return (
    <Nav tabs className="mb-4">
      {abas.map((i) => (
        <NavItem key={i.to}>
          <NavLink to={i.to} className="nav-link">
            {i.label}
          </NavLink>
        </NavItem>
      ))}
    </Nav>
  );
}
